import { styled } from '@mui/material';
import { up } from '../../../../theme';

export const classes = {
  root: 'root',
  MainBox: 'MainBox',
  ActionIcons: 'ActionIcons',
  organizationsScanHistoryAgGridStyle: 'organizationsScanHistoryAgGridStyle',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.MainBox}`]: {
    height: `calc(100vh - ${theme.spacing(6)})`,
    [up('xs')]: {
      padding: '20px 14px',
    },
    [up('sm')]: {
      padding: '20px 16px',
    },
    [up('md')]: {
      padding: '23px 18px',
    },
    [up('lg')]: {
      padding: '25px 20px',
    },
    [up('xl')]: {
      padding: '30px 23px',
    },
    [up('xxl')]: {
      padding: '35px 25px',
    },
  },
  [`& .${classes.ActionIcons}`]: {
    marginRight: '2vw',
    marginTop: '9px',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
  [`& .${classes.organizationsScanHistoryAgGridStyle}`]: {
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '70vh',
    },
    [up('lg')]: {
      height: '72vh',
    },
    [up('xl')]: {
      height: '79vh',
    },
    [up('xxl')]: {
      height: '81vh',
    },
  },
}));
